module.exports = require("react-split-pane");